var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResult(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 155,
    viewBox: "0 0 274 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6430_28481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6797 96.8984H41.4997",
    stroke: "#DFE5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.01 90.6381C7.01 92.3781 8.42 93.7981 10.17 93.7981C11.01 93.7981 11.77 93.4681 12.34 92.9381C12.95 92.3581 13.33 91.5481 13.33 90.6381V90.6181C13.33 87.1481 10.51 84.3281 7.04 84.3281C3.57 84.3281 0.75 87.1481 0.75 90.6181C0.75 94.0881 3.57 96.9081 7.04 96.9081H23.02",
    stroke: "#DFE5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.17 13.6289L0.75 13.7389",
    stroke: "#DFE5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8296 7.06V7.04C38.8296 3.57 41.6496 0.75 45.1196 0.75C48.5896 0.75 51.4096 3.57 51.4096 7.04C51.4096 10.51 48.5896 13.33 45.1196 13.33L20.8496 13.55",
    stroke: "#DFE5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.32 125.401C243.32 127.751 245.22 129.651 247.57 129.651C248.7 129.651 249.72 129.211 250.49 128.491C251.31 127.711 251.83 126.611 251.83 125.391V125.361C251.83 120.681 248.04 116.891 243.36 116.891C238.68 116.891 234.89 120.681 234.89 125.361C234.89 130.041 238.68 133.831 243.36 133.831H226.4",
    stroke: "#DFE5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.049 18.96C271.999 14.82 268.249 11.75 263.789 11.75C260.859 11.75 258.229 13.07 256.469 15.15C255.059 16.82 254.219 18.97 254.219 21.32C254.219 21.52 254.239 21.72 254.249 21.92C253.299 21.53 252.259 21.32 251.169 21.32C246.639 21.32 242.969 24.99 242.969 29.52C242.969 34.05 246.639 37.72 251.169 37.72H231.529",
    stroke: "#DEE4FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9006 53.4497C49.0107 53.4497 49.9106 52.5498 49.9106 51.4397C49.9106 50.3296 49.0107 49.4297 47.9006 49.4297C46.7905 49.4297 45.8906 50.3296 45.8906 51.4397C45.8906 52.5498 46.7905 53.4497 47.9006 53.4497Z",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.229 90.2773H232.119",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.68 91.8288V88.7188",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3698 137.723H66.2598",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8203 139.282V136.172",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7903 56.4883H38.5703",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6797 59.5989V53.3789",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.681 96.0391H227.461",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.57 99.1497V92.9297",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.871 63.4297H195.311",
    stroke: "#DEE4FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.009 153.738H69.3691",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.641 154.268C183.441 154.268 186.801 152.428 188.901 149.598C190.321 147.688 191.151 145.318 191.151 142.758H181.241V127.988H192.971C194.321 127.988 195.411 129.078 195.411 130.428V154.268H179.631H179.641Z",
    fill: "#2866AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.08 150.8C200.12 150.8 204.2 146.96 204.2 142.23C204.2 137.5 200.12 133.66 195.08 133.66",
    stroke: "#2866AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.519 83.3983H156.849C163.069 83.3983 168.109 78.3583 168.109 72.1383C168.109 65.9183 163.069 60.8783 156.849 60.8783C155.349 60.8783 153.929 61.1783 152.619 61.7083C152.639 61.4283 152.659 61.1583 152.659 60.8783C152.659 53.6183 146.779 47.7383 139.519 47.7383C133.379 47.7383 128.249 51.9483 126.799 57.6383C125.829 57.1183 124.729 56.8283 123.559 56.8283C119.769 56.8283 116.699 59.8983 116.699 63.6883C116.699 63.6983 116.699 63.7083 116.699 63.7183C116.479 63.7083 116.269 63.6883 116.039 63.6883C110.329 63.6883 105.699 68.0983 105.699 73.5483C105.699 78.9983 110.329 83.4083 116.039 83.4083H129.289",
    stroke: "#2866AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.77 105.102H109.73C107.25 105.102 105.24 107.112 105.24 109.592C105.24 112.071 107.25 114.082 109.73 114.082H163.77C166.25 114.082 168.26 112.071 168.26 109.592C168.26 107.112 166.25 105.102 163.77 105.102Z",
    stroke: "#2866AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.45 105.102H109.92C107.44 105.102 105.43 107.112 105.43 109.592C105.43 112.071 107.44 114.082 109.92 114.082H132.45C134.929 114.082 136.94 112.071 136.94 109.592C136.94 107.112 134.929 105.102 132.45 105.102Z",
    fill: "#2866AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.141 72.9102H175.991C178.901 72.9102 181.251 75.2702 181.251 78.1702V142.22",
    stroke: "#2866AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6309 142.232V78.1819C92.6309 75.2719 94.9909 72.9219 97.8909 72.9219H105.741",
    stroke: "#2866AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.969 142.23C190.969 144.79 190.129 147.16 188.719 149.07C186.619 151.9 183.259 153.74 179.279 153.74H93.8693C87.6893 153.74 82.5293 148.59 82.5293 142.23H190.969Z",
    fill: "#ECF2FF",
    stroke: "#2866AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.701 105.101V94.0508H117.331C115.751 94.0508 114.461 95.3308 114.461 96.9208V105.101H155.701Z",
    fill: "#ECF2FF",
    stroke: "#2866AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.949 94.0384V93.0184C123.949 91.4284 125.239 90.1484 126.819 90.1484H159.599V105.098H155.699V94.0484H123.949V94.0384Z",
    fill: "#ECF2FF",
    stroke: "#2866AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.599 114.27V129.39C159.599 130.98 158.309 132.26 156.729 132.26H155.709L155.529 114.07L159.609 114.27H159.599Z",
    fill: "#ECF2FF",
    stroke: "#2866AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.821 136.28H152.131C154.001 136.3 155.521 134.78 155.521 132.91V114.07H114.251L114.211 136.19L136.981 136.26",
    fill: "#ECF2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.821 136.28H152.131C154.001 136.3 155.521 134.78 155.521 132.91V114.07H114.251L114.211 136.19L136.981 136.26",
    stroke: "#2866AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.109 122.012H136.679H149.769",
    stroke: "#2866AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.109 128.68H132.839H141.939",
    stroke: "#2866AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.16 121.391C185.16 121.391 184.31 121.951 185.08 122.751C185.77 123.481 184.88 124.111 184.88 124.111",
    stroke: "#2866AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.52 122.172C188.52 122.172 187.67 122.732 188.44 123.532C189.13 124.262 188.24 124.892 188.24 124.892",
    stroke: "#2866AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.689 82.6105C136.349 82.6105 136.009 82.6105 135.679 82.6105C135.649 82.6105 135.649 82.6305 135.649 82.6505C135.649 83.6405 135.649 84.6205 135.649 85.6105C135.649 85.8905 135.549 86.1205 135.269 86.2405C135.209 86.2605 135.159 86.2705 135.109 86.2705C134.569 86.2705 134.019 86.2705 133.479 86.2705C133.279 86.2705 132.999 86.0205 132.969 85.8105C132.949 85.7005 132.969 85.5905 132.969 85.4805C132.969 84.5305 132.969 83.5905 132.969 82.6405C132.969 82.6205 132.969 82.6005 132.939 82.6005C132.619 82.6005 132.289 82.5805 131.969 82.6005C131.789 82.6005 131.659 82.5505 131.559 82.4005C131.539 82.3505 131.509 82.3105 131.489 82.2605C131.479 82.0505 131.569 81.8805 131.719 81.7405C132.449 81.0105 133.179 80.2805 133.909 79.5505C134.169 79.2905 134.419 79.2905 134.689 79.5505C135.439 80.3005 136.179 81.0505 136.929 81.7905C137.069 81.9205 137.109 82.0805 137.139 82.2505C137.159 82.3805 136.879 82.6005 136.709 82.6005L136.689 82.6105Z",
    fill: "#2866AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.5 84.8917C142.39 85.0017 142.27 85.1117 142.16 85.2217C141.47 85.9117 140.78 86.6117 140.09 87.3017C139.89 87.5017 139.6 87.4717 139.41 87.2717C138.66 86.4917 137.9 85.7417 137.13 84.9817C136.98 84.8317 136.91 84.6717 136.98 84.4817C137.05 84.2717 137.25 84.2117 137.45 84.2017C137.73 84.2017 138.01 84.2017 138.29 84.2017C138.39 84.2017 138.43 84.2017 138.43 84.0717C138.43 83.1017 138.43 82.1217 138.43 81.1517C138.43 80.7917 138.58 80.5717 138.93 80.5417C139.47 80.5017 140.01 80.4917 140.54 80.5417C141.02 80.5817 141.1 80.8317 141.11 81.2417C141.12 82.1717 141.11 83.1017 141.11 84.0317C141.11 84.0817 141.11 84.1217 141.11 84.1717C141.11 84.2017 141.11 84.2017 141.14 84.2017H142.1C142.1 84.2017 142.16 84.2117 142.18 84.1717C142.25 84.2417 142.35 84.2417 142.42 84.3217C142.58 84.4917 142.6 84.6317 142.49 84.8917H142.5Z",
    fill: "#2866AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6430_28481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273.8,
    height: 154.27,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResult);
export default __webpack_public_path__ + "static/media/result.6fddfd287b189fccbdf2aaa4cb1f9000.svg";
export { ForwardRef as ReactComponent };